import { request } from 'cn-request';
/**
 * 请求类型
 */
var REQUEST_TYPE;
(function (REQUEST_TYPE) {
    /** 获取部门 */
    REQUEST_TYPE["GET_DEPT"] = "GET_GEPT";
    /**
     * 获取子节点
     */
    REQUEST_TYPE["GET_CHILDREN"] = "GET_CHILDREN";
    /**
     * 搜索
     */
    REQUEST_TYPE["SEARCH"] = "SEARCH";
})(REQUEST_TYPE || (REQUEST_TYPE = {}));
/**
 * 内置接口名称
 */
const INTERNAL_PATH_MAP = {
    /**
     * 获取部门
     */
    [REQUEST_TYPE.GET_DEPT]: '/cmdp/hysmab/getDepartmentInfo',
    /**
     * 获取子部门
     */
    [REQUEST_TYPE.GET_CHILDREN]: '/cmdp/hysmab/getSubDepartmentInfo',
    /**
     * 搜索
     */
    [REQUEST_TYPE.SEARCH]: '/cmdp/hysmab/searchDepartmentInfo',
};
/**
 * 非mokelay直接接入时的代理地址
 */
const NON_MOKELY_PROXY_PATH = '/cn-common-proxy/post';
/**
 * 拼接请求参数
 */
function buildRequestParams(params) {
    const { data, type, mokelay = false, host = '', path = '' } = params;
    // 拼接地址，优先外部传入的path，其次host+mokelay判断
    const innerPath = INTERNAL_PATH_MAP[type];
    const builtPath = path || (mokelay ? innerPath : NON_MOKELY_PROXY_PATH);
    // 拼接参数
    const builtData = path || mokelay
        ? data
        : {
            path: innerPath,
            params: data,
        };
    // 最终请求参数
    const builtParams = {
        url: `${host}${builtPath}`,
        method: 'post',
        withCredentials: true,
        data: builtData,
    };
    return builtParams;
}
/**
 * 格式化返回数据
 * @param res 原始返回数据
 * @returns 格式化后可被下拉组件使用的数据
 */
function formatResponse(res) {
    const resultData = Array.isArray(res.data?.data) ? res.data?.data : res?.data;
    if (!Array.isArray(resultData))
        return [];
    return resultData
        .filter((item) => item?.enabled !== false)
        .map((item) => ({
        ...item,
        label: item.name,
        fullName: `${item.fullName || item.name}`.replace(/(^菜鸟集团-菜鸟-菜鸟-)|(菜鸟集团-菜鸟-菜鸟-$)/g, ''),
        value: item.code,
        isLeaf: !item.hasSubDepartment,
    }));
}
/**
 * 获取部门
 */
export async function getDept(params) {
    const { mokelay, host, path, value = '' } = params;
    const requestParams = buildRequestParams({
        type: REQUEST_TYPE.GET_DEPT,
        data: {
            departmentCode: value,
            isCommonRequest: true,
        },
        mokelay,
        host,
        path,
    });
    const result = await request(requestParams);
    const fomattedResult = formatResponse(result);
    return fomattedResult;
}
/**
 * 获取子节点（父级部门获取子部门）
 */
export async function getChildren(params) {
    const { mokelay, host, path, value = '' } = params;
    const requestParams = buildRequestParams({
        type: REQUEST_TYPE.GET_CHILDREN,
        data: {
            departmentCode: value,
            isCommonRequest: true,
        },
        mokelay,
        host,
        path,
    });
    const result = await request(requestParams);
    const fomattedResult = formatResponse(result);
    return fomattedResult;
}
/**
 * 搜索（按关键词查询部门）
 */
export async function search(params) {
    const { mokelay, host, path, value = '' } = params;
    const requestParams = buildRequestParams({
        type: REQUEST_TYPE.SEARCH,
        data: {
            searchKey: value,
            isCommonRequest: true,
        },
        mokelay,
        host,
        path,
    });
    const result = await request(requestParams);
    const fomattedResult = formatResponse(result);
    return fomattedResult.map((i) => ({
        ...i,
        label: i.fullName || i.label,
    }));
}
